// signalr base
import Vue from 'vue';

const signalR = require('@microsoft/signalr');

if (!process.env.NODE_ENV === 'development') {
  let baseURL = 'wss://' + window.location.hostname + '/socketApi/canadacasinohub';
  baseURL = baseURL.replace(/^https?\:\/\//i, 'ws://');
} else {
  let baseURL = process.env.VUE_APP_CASINO_SOCKET_URL;
}

const connectionStates = {
  connecting: 0,
  connected: 1,
  reconnecting: 2,
  disconnected: 4,
};

let connection;
const init = () => {
  if (connection) return;
  connection = new signalR.HubConnectionBuilder()
    .withUrl(baseURL, {
      skipNegotiation: true,
      transport: signalR.HttpTransportType.WebSockets,
    })
    .configureLogging(signalR.LogLevel.Information)
    .build();
};
const connect = onError => {
  return new Promise((resolve, reject) => {
    if (!connection) {
      init();
    }
    connection
      .start()
      .then(() => {
        resolve({
          state: connectionStates.connected,
        });

        connection.onclose(e => {
          onError();
        });

        connection.onerror(e => {
          onError();
        });
      })
      .catch(rej => {
        reject(rej);
      });
  });
};

const disconnect = () => {
  return new Promise((resolve, reject) => {
    init();
    connection
      .stop()
      .then(res => {
        resolve({
          state: connectionStates.disconnected,
        });
      })
      .catch(rej => {
        reject(rej);
      });
  });
};

const subscribe = (method, callBack) => {
  connection.on(method, function(args) {
    callBack(args);
  });
};

const invoke = (method, args) => {
  connection.invoke(method, args);
};

const _casinoSignalR = {
  connect,
  subscribe,
  invoke,
  disconnect,
  connection: connection,
};

Vue.prototype.$casinoSignlaR = _casinoSignalR;

export const socket = {
  connectionStates,
  _casinoSignalR,
};
